// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-1qprcsu-option{
    text-align: left;
    min-width: 95% !important; /* code added for width of dropdown */
}
.css-1vr111p-option{
    text-align: left;
    min-width: 95% !important; /* code added for width of dropdown */
}
.css-1r4vtzz{
    width: 100% !important;
}
.css-48ayfv{
    width: 100% !important;
}

/* code added for width of dropdown */
.css-48ayfv+div {
    width: 100%;
}
.css-1jllj6i-control{
    min-width: 95% !important;
}
.css-19t9a5b-control{
    min-width: 95% !important;
}
.css-vb64bg-control:hover{
    min-width: 95% !important;
}
.css-vb64bg-control {
    min-width: 95% !important;
}
.css-6y1x9t-control:hover {
    min-width: 95% !important;
}
.css-6y1x9t-control {
    min-width: 95% !important;
}
/* code added for width of dropdown */

input{
    height: inherit
}

.react-select__option{
    font-size: 80% !important;
}

.react-select__option1{
    font-size: 100% !important;
}

.react-select__menu-list{
    max-height: 150px !important;
    -webkit-overflow-scrolling:auto !important;
}

.bus_filtr_btn{
    position: relative;
    top: 10px;
}
.font-bus-head {
    font-size: 16px !important;
    font-weight: bolder;
    color: #000;
}
.font-bus-head_a {
    font-size: 16px !important;
    font-weight: bolder;
    color: #000;
    text-align: left;
}
.font-bus-head_pg{
    font-size: 1.25rem !important;
    color: #000;
    font-weight: 600;
}
.filter_bus_icon {
    background: #fff !important;
    color: #83A4CF !important;
    padding: 0px 9px;
    font-size: 22px;
}
/* .filter_bus_icon:hover{
    background: #83A4CF !important;
    color: #fff !important;
} */
/* added code filter */
.filter_bus_icon_f .btn:focus, .btn:focus-visible, .btn:focus-within, .btn:hover, .btn:visited, .btn:active, .btn:target{
    background-color: #83A4CF !important;
    border-color: #83A4CF !important;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Driveanalysis_Bus/CustomSelect_Bus.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,yBAAyB,EAAE,qCAAqC;AACpE;AACA;IACI,gBAAgB;IAChB,yBAAyB,EAAE,qCAAqC;AACpE;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;;AAEA,qCAAqC;AACrC;IACI,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA,qCAAqC;;AAErC;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;AACA;;;GAGG;AACH,sBAAsB;AACtB;IACI,oCAAoC;IACpC,gCAAgC;AACpC","sourcesContent":[".css-1qprcsu-option{\r\n    text-align: left;\r\n    min-width: 95% !important; /* code added for width of dropdown */\r\n}\r\n.css-1vr111p-option{\r\n    text-align: left;\r\n    min-width: 95% !important; /* code added for width of dropdown */\r\n}\r\n.css-1r4vtzz{\r\n    width: 100% !important;\r\n}\r\n.css-48ayfv{\r\n    width: 100% !important;\r\n}\r\n\r\n/* code added for width of dropdown */\r\n.css-48ayfv+div {\r\n    width: 100%;\r\n}\r\n.css-1jllj6i-control{\r\n    min-width: 95% !important;\r\n}\r\n.css-19t9a5b-control{\r\n    min-width: 95% !important;\r\n}\r\n.css-vb64bg-control:hover{\r\n    min-width: 95% !important;\r\n}\r\n.css-vb64bg-control {\r\n    min-width: 95% !important;\r\n}\r\n.css-6y1x9t-control:hover {\r\n    min-width: 95% !important;\r\n}\r\n.css-6y1x9t-control {\r\n    min-width: 95% !important;\r\n}\r\n/* code added for width of dropdown */\r\n\r\ninput{\r\n    height: inherit\r\n}\r\n\r\n.react-select__option{\r\n    font-size: 80% !important;\r\n}\r\n\r\n.react-select__option1{\r\n    font-size: 100% !important;\r\n}\r\n\r\n.react-select__menu-list{\r\n    max-height: 150px !important;\r\n    -webkit-overflow-scrolling:auto !important;\r\n}\r\n\r\n.bus_filtr_btn{\r\n    position: relative;\r\n    top: 10px;\r\n}\r\n.font-bus-head {\r\n    font-size: 16px !important;\r\n    font-weight: bolder;\r\n    color: #000;\r\n}\r\n.font-bus-head_a {\r\n    font-size: 16px !important;\r\n    font-weight: bolder;\r\n    color: #000;\r\n    text-align: left;\r\n}\r\n.font-bus-head_pg{\r\n    font-size: 1.25rem !important;\r\n    color: #000;\r\n    font-weight: 600;\r\n}\r\n.filter_bus_icon {\r\n    background: #fff !important;\r\n    color: #83A4CF !important;\r\n    padding: 0px 9px;\r\n    font-size: 22px;\r\n}\r\n/* .filter_bus_icon:hover{\r\n    background: #83A4CF !important;\r\n    color: #fff !important;\r\n} */\r\n/* added code filter */\r\n.filter_bus_icon_f .btn:focus, .btn:focus-visible, .btn:focus-within, .btn:hover, .btn:visited, .btn:active, .btn:target{\r\n    background-color: #83A4CF !important;\r\n    border-color: #83A4CF !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
